import { useEffect } from 'react';

import { MAP_LAYERS } from './constants.js';
import { UseMapProps } from './types.js';

type Props<Feature> = {
  mapRef: UseMapProps<Feature>['mapRef'];
  isEnabled: boolean;
};

export function usePinLayerCursor<Feature>({ mapRef, isEnabled }: Props<Feature>) {
  useEffect(() => {
    if (!isEnabled) return;

    const map = mapRef.current?.getMap();
    const draw = mapRef.current?.getDraw();
    if (!map || !draw) return;

    const handleClick = () => {
      draw.changeMode('simple_select');
    };
    const handleMouseEnter = () => {
      map.getCanvas().style.cursor = 'pointer';
    };
    const handleMouseLeave = () => {
      map.getCanvas().style.cursor = '';
    };

    map.on('click', MAP_LAYERS.PINS, handleClick);
    map.on('mouseenter', MAP_LAYERS.PINS, handleMouseEnter);
    map.on('mouseleave', MAP_LAYERS.PINS, handleMouseLeave);

    return () => {
      map.off('click', MAP_LAYERS.PINS, handleClick);
      map.off('mouseenter', MAP_LAYERS.PINS, handleMouseEnter);
      map.off('mouseleave', MAP_LAYERS.PINS, handleMouseLeave);
    };
  }, [isEnabled, mapRef]);
}
